import React from 'react'
import { makeStyles, TableCell } from '@material-ui/core'

type Props = {
  children?: string
  value?: string
  highlight?: boolean
}

const useStyles = makeStyles(() => ({
  tableValueCell: {
    textAlign: 'center',
  },
  highlightFont: {
    fontWeight: 'bold',
  },
}))

export function TableValueCell({
  children,
  value = children,
  highlight = false,
}: Props): React.ReactElement {
  const classes = useStyles()
  const cellClass = highlight
    ? `${classes.highlightFont} ${classes.tableValueCell}`
    : classes.tableValueCell

  return <TableCell className={cellClass}>{value}</TableCell>
}
